import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";

import router from "@/router";
// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";
// import { getUserData } from "@/auth/utils";
import { getDateTime } from "@/libs/helper";


export default function useAdvancePaymentsList() {
  // Use toast
  const toast = useToast();

  const refAdvancePaymentListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    {
      key: "prepayment_number", label: "編號", class: 'sticky-column', sortable: true
    },
    { key: "user.name_cn", label: "申請人" },
    { key: "show_details", label: "款項摘要" },
    { key: "actions", label: "操作" , class: 'sticky-column'},
    { key: "prepayment_status", label: "預支狀態", sortable: true },
    // { key: "payment_date", label: "領取日期" },
    { key: "total_amount", label: "總預支金額", sortable: true, formatter: formatCurrency },
    { key: "received_amount", label: "總接收金額", sortable: true, formatter: formatCurrency },
    { key: "used_amount", label: "已使用金額(已批核)", sortable: true, formatter: formatCurrency },
    { key: "pending_amount", label: "待批核金額", sortable: true, formatter: formatCurrency },
    { key: "rejected_amount", label: "已拒絕金額", sortable: true, formatter: formatCurrency },
    { key: "refunded_amount", label: "已退還金額", sortable: true, formatter: formatCurrency },
    { key: "balance", label: "餘額", sortable: true, formatter: formatCurrency },
    { key: "invoice_number", label: "發票編號" , class: 'sticky-column'},
    { key: "invoice_address", label: "工程地址" },
    { key: "request_date", label: "預支申請日期", sortable: true },
    { key: "receipt_date", label: "收款日期", sortable: true },
    { key: "receive_method", label: "收款方式" },
    { key: "check_number", label: "支票號碼" },
    { key: "purpose", label: "預支備註", sortable: true },
   
    // { key: "is_approved", label: "已批核" },
    // { key: "approve_remark", label: "批核備註" },
    // { key: "approve_date", label: "審批日期" },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("request_date");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refAdvancePaymentListTable.value
      ? refAdvancePaymentListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refAdvancePaymentListTable.value.refresh();
  };

  const advancePaymentsList = ref(null);
  // 是否在用戶自己頁
  const is_user_page = ref(false);

  const fetchAdvancePayments = (ctx, callback) => {
    console.log(router.currentRoute.name)
    if (router.currentRoute.name == 'worker-advance-payment-list') {
      var url = 'fetchSelfAdvancePayments'
      // var url = 'fetchAdvancePayments'
      is_user_page.value = true
    } else {
      var url = 'fetchAdvancePayments'
      is_user_page.value = false
    }
    store.dispatch(`advance-payment/${url}`, {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      user_id: filter_user_id.value,
      project_id: filter_project_id.value,
      is_approved: filter_approval_id.value,
      prepayment_status_id: filter_prepayment_status_id.value,
    })
      .then((response) => {
        const { prepaymentes, total } = response.data;
        prepaymentes.forEach(ele => ele.approve_status_id = ele.approve_status_id ? ele.approve_status_id : 1)

        callback(prepaymentes);
        totalRow.value = total;
        advancePaymentsList.value = prepaymentes
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const filter_user_id = ref(null);
  const filter_project_id = ref(null);
  const filter_approval_id = ref(null);
  const filter_prepayment_status_id = ref(null);
  watch(
    [currentPage, perPage, searchQuery, filter_user_id, filter_project_id, filter_approval_id, filter_prepayment_status_id],
    () => {
      refetchData();
    }
  );

  const projectOptions = ref([]);
  const productOptions = ref([]);
  const approvalStatusOptions = ref([]);
  const prepaymentStatusOptions = ref([]);
  const productCategoriesOptions = ref([]);
  const receiveMethodOptions = ref([]);
  const userOptions = ref([]);
  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        projects: true,
        products: true,
        workers: true,
        approve_status: true,
        prepayment_statuses: true,
        product_categories: true,
        receive_methods: true,
        users: true,
      })
      .then((response) => {
        // projectOptions.value = is_user_page.value ? 
        // response.data.projects.filter(
        //   ele => 
        //     (ele.users.length > 0 && ele.users.find(user => user.id == getUserData().id)) || ele.manager_id == getUserData().id
        // ) 
        // : response.data.projects;
        projectOptions.value = response.data.projects

        productOptions.value = response.data.products;
        // 使用 userOptions 過濾出員工 (user_type_id = 1) 和師傅 (user_type_id = 4)
        userOptions.value = response.data.users.filter(user => user.user_type_id === 1 || user.user_type_id === 4);
        approvalStatusOptions.value = response.data.approve_statuses;
        prepaymentStatusOptions.value = response.data.prepayment_statuses;
        productCategoriesOptions.value = response.data.product_categories;
        receiveMethodOptions.value = response.data.receive_methods.sort ((a, b) => a.sort_order - b.sort_order);
      });
  };

  onMounted(() => {
    refetchOption();
  });

  // 匯出記錄的主要函數
  const exportRecords = (exportType) => {
    return new Promise((resolve, reject) => {
      let dataToExport;

      if (exportType === 'current') {
        // 匯出當前頁面數據
        dataToExport = advancePaymentsList.value;
        processExportData(dataToExport, resolve);
      } else {
        // 匯出全部數據 - 需要重新獲取所有記錄
        const url = is_user_page.value ? 'fetchSelfAdvancePayments' : 'fetchAdvancePayments';

        store
          .dispatch(`advance-payment/${url}`, {
            q: searchQuery.value,
            perPage: 999999, // 獲取所有記錄
            page: 1,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            user_id: filter_user_id.value,
            project_id: filter_project_id.value,
            is_approved: filter_approval_id.value,
            prepayment_status_id: filter_prepayment_status_id.value,
          })
          .then((response) => {
            const { prepaymentes } = response.data;
            processExportData(prepaymentes, resolve);
          })
          .catch((error) => {
            console.error('獲取全部記錄失敗:', error);
            reject(error);
          });
      }
    });
  };

  // 處理匯出數據的共用函數
  const processExportData = (dataToExport, resolve) => {
    // 按預支日期排序數據
    const sortedData = [...dataToExport].sort((a, b) => {
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return dateB - dateA; // 降序排列（最新的在前）
    });

    // 準備匯出數據
    const exportData = [];

    sortedData.forEach((item) => {
      // 處理款項摘要的格式化
      const summary = formatSummary(item);

      exportData.push({
        '編號': item.prepayment_number || '',
        '申請人': item.user?.name_cn || '',
        '款項摘要': summary,
        '總預支金額': formatCurrency(item.total_amount),
        '總接收金額': formatCurrency(item.received_amount),
        '已使用金額(已批核)': formatCurrency(item.used_amount),
        '待批核金額': formatCurrency(item.pending_amount),
        '已拒絕金額': formatCurrency(item.rejected_amount),
        '已退還金額': formatCurrency(item.refunded_amount),
        '餘額': formatCurrency(item.balance),
        '發票編號': item.invoice?.invoice_number || '',
        '工程地址': item.invoice?.address || '',
        '預支申請日期': item.request_date || '',
        '收款方式': getReceiveMethodName(item.receive_method_id),
        '支票號碼': item.check_number || '',
        '收款日期': item.receipt_date || '',
        '預支狀態': item.prepayment_status?.name || '',
        '預支備註': item.purpose || '',
        '創建日期': getDateTime(item.created_at, true) || '',
      });
    });

    resolve(exportData);
  };

  // 格式化款項摘要的函數
  const formatSummary = (item) => {
    const summaryParts = [];

    // 處理 transactions 資訊
    if (item.transactions && item.transactions.length > 0) {
      summaryParts.push('預支金額');
      item.transactions.forEach((transaction) => {
        const user = userOptions.value?.find(u => u.id === transaction.user_id);
        const userName = user?.name_cn || '未知用戶';
        const approvalStatus = transaction.is_approved ? '已批核' : (transaction.is_rejected ? '已拒絕' : '待批核');
        const amount = Number(transaction.amount || 0).toFixed(0);
        const adminRemark = transaction.admin_remark || '--';
        const approveDate = transaction.approve_date || '--';
        const description = transaction.description || '--';

        summaryParts.push(`金額：$${amount}           批核狀態：${approvalStatus}`);
        summaryParts.push(`備註：${description}           批核備註：${adminRemark}`);
        summaryParts.push(`接收人：${userName}     批核日期：${approveDate}`);
        summaryParts.push(''); // 空行
      });
    }

    // 處理 salary_records 資訊
    if (item.salary_records && item.salary_records.length > 0) {
      if (summaryParts.length > 0 && summaryParts[summaryParts.length - 1] !== '') {
        summaryParts.push(''); // 空行分隔
      }
      summaryParts.push('工資');

      item.salary_records.forEach((record) => {
        const user = userOptions.value?.find(u => u.id === record.user_id);
        const userName = user?.name_cn || '未知用戶';
        const position = user?.position || '';
        const approvalStatus = record.is_approved ? '已批核' : (record.is_rejected ? '已拒絕' : '待批核');
        const adminRemark = record.admin_remark || '--';
        const approveDate = record.approve_date || '--';
        const remark = record.remark || '--';
        const totalSalary = Number(record.total_salary || 0).toFixed(0);

        const workerInfo = position ? `[${position}] ${userName}` : userName;

        // 根據薪資類型顯示不同格式
        const salaryType = item.salary_type;
        let salaryTypeName = '';
        if (salaryType === 1) {
          salaryTypeName = '日薪';
        } else if (salaryType === 2) {
          salaryTypeName = '月薪';
        } else if (salaryType === 3) {
          salaryTypeName = '以工程項目計算';
        }

        summaryParts.push(`計薪方式：${salaryTypeName}                   批核狀態：${approvalStatus}`);
        summaryParts.push(`員工：${workerInfo}      批核備註：${adminRemark}`);

        // 根據薪資類型顯示不同的時間資訊
        if (salaryType === 1) {
          // 日薪 - 顯示工作天數
          const workingDays = record.working_days || 0;
          const daySalary = Number(record.day_salary || 0).toFixed(0);
          summaryParts.push(`工作天數：${workingDays}天 × $${daySalary}       批核日期：${approveDate}`);
        } else if (salaryType === 2) {
          // 月薪 - 顯示出糧月份
          const salaryYear = item.salary_year || '';
          const salaryMonth = item.salary_month || '';
          const yearMonth = salaryYear && salaryMonth ? `${salaryYear}年 ${salaryMonth}月` : '--';
          summaryParts.push(`出糧月份：${yearMonth}       批核日期：${approveDate}`);
        } else if (salaryType === 3) {
          // 以工程項目計算 - 顯示項目資訊
          summaryParts.push(`項目工資                     批核日期：${approveDate}`);
        }

        summaryParts.push(`預支金額：$${totalSalary}`);
        summaryParts.push(`備註：${remark}`);
        summaryParts.push(''); // 空行
      });
    }

    // 移除最後的空行
    while (summaryParts.length > 0 && summaryParts[summaryParts.length - 1] === '') {
      summaryParts.pop();
    }

    return summaryParts.join('\n');
  };

  // 輔助函數
  const getReceiveMethodName = (methodId) => {
    const method = receiveMethodOptions.value?.find(m => m.id === methodId);
    return method?.name || '';
  };

  const formatCurrency = (amount) => {
    const num = Number(amount || 0);
    return `$${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  return {
    fetchAdvancePayments,
    tableColumns,
    perPage,
    totalRow,
    currentPage,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    dataMeta,
    advancePaymentsList,
    refAdvancePaymentListTable,
    ability,
    refetchData,
    filter_user_id,
    filter_project_id,
    filter_approval_id,
    filter_prepayment_status_id,
    projectOptions,
    productOptions,
    approvalStatusOptions,
    prepaymentStatusOptions,
    productCategoriesOptions,
    receiveMethodOptions,
    getReceiveMethodName,
    userOptions,
    is_user_page,
    exportRecords,
  };
}
